<!--
 * @Descripttion: 收藏流程列表
 * @Author: jschen
 * @Date: 2021-09-05 16:39:41
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-24 15:16:33
-->
<template>
    <div v-show="visible" class="approval-content collect-content-container">
        <el-table
            v-loading="loading"
            :data="collectRecords"
            style="width: 100%"
            :height="255"
            @row-click="rowCollectClick"
        >
            <el-table-column prop="title" label="流程标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span
                        ><span :class="levelStyle(scope.row.alarmLevel)">[{{ levelStatus(scope.row.alarmLevel) }}]</span
                        >{{ scope.row.title }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column prop="creatorRealName" label="创建人" align="center" width="150"> </el-table-column>
            <el-table-column prop="createDate" sortable label="接收时间" align="center" width="150">
                <template slot-scope="scope">
                    <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="collect" label="收藏" align="center" width="150">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="!scope.row.collect ? '收藏' : '从收藏移除'"
                        placement="top-end"
                    >
                        <span
                            v-show="scope.row.flowFrom !== 'EKP_OA'"
                            :class="{
                                'is-star': !scope.row.collect,
                                'is-active-star': scope.row.collect,
                            }"
                            @click.stop="starCollect(scope.row)"
                        ></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <div slot="append" style="width:100%;height:30px;"></div>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
    </div>
</template>
<script>
import { queryApproval, handleCollect } from "@/api";
import { isMobile } from "@/libs/mUtils";
import _ from "lodash";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            collectRecords: [],
            searchCollectOpt: {
                title: "", // 标题
                taskType: null,
                handleType: null,
                handleGroup: "ALL",
                isCollect: true,
                current: 1,
                size: 30,
            },
        };
    },
    computed: {
        levelStatus() {
            return function(status) {
                let level = parseInt(status);
                let levelName = "一般";
                switch (level) {
                    case 1:
                        levelName = "紧急";
                        break;
                    case 2:
                        levelName = "重要";
                        break;
                    default:
                        levelName = "一般";
                        break;
                }
                return levelName;
            };
        },
        levelStyle() {
            return function(level) {
                return `level${level}`;
            };
        },
    },
    methods: {
        loadData() {
            this.getCollectList();
        },
        refresh() {
            const { title } = _.cloneDeep(this.searchCollectOpt);
            this.searchCollectOpt = {
                title: title, // 标题
                taskType: null,
                handleType: null,
                handleGroup: "ALL",
                isCollect: true,
                current: 1,
                size: 30,
            };
            this.loadData();
        },
        changeSearchOps(item) {
            this.searchCollectOpt = {
                ...this.searchCollectOpt,
                ...item,
            };
        },
        starCollect(row) {
            const { id, collect } = row;
            this.handleCollect({
                id,
                isCollect: !collect,
            });
        },
        rowCollectClick({ mobileLink, link }) {
            if (isMobile()) {
                window.open(mobileLink);
                return;
            }
            window.open(link);
        },
        // 流程草稿
        async getCollectList() {
            this.loading = true;
            try {
                const { body, code, message } = await queryApproval({
                    ...this.searchCollectOpt,
                    username: this.userAuthName,
                });
                if (code === "0000") {
                    this.collectRecords = body.records;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        // 查询收藏列表
        async handleCollect(params) {
            this.loading = true;
            try {
                const { code, message } = await handleCollect({
                    ...params,
                });
                if (code === "0000") {
                    const message = params.isCollect ? "已添加至收藏" : "已取消收藏";
                    this.$message[params.isCollect ? "success" : "warning"](message);
                    this.$emit("reload");
                    this.getCollectList();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.collect-content-container {
    /deep/ .el-table__header-wrapper {
        thead {
            th:nth-last-child(2) {
                .cell {
                    padding-right: 8px !important;
                }
            }
        }
    }
}
</style>
